module.exports = __webpack_public_path__ + "static/media/CreditCardIcon.1919bf23.svg";